<div
  class="sidenav-item"
  [ngClass]="isSelected ? 'selected' : 'un-selected'"
>
  <button type="button" class="sidenav-main" (click)="sidenavClicked()">
    <div class="d-flex justify-content-center">
      <i [ngClass]="[icon, 'iconText']"></i>
    </div>

    <div class="d-flex justify-content-center">
      <p class="itemText">{{ text }}</p>
    </div>
  </button>

  @if (expand.length) {
    <ng-container>
      <div class="expand-arrow d-flex justify-content-center" (click)="sidenavClicked()">
        <i class="fa chevron" [ngClass]="isSelected ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>

      <div class="expand-container" [ngStyle]="{'--count': isSelected ? visibleItems.length : 0}">
        @for (data of visibleItems; track data.id; let i = $index) {
          <a
            class="expand-item text-decoration-none"
            [class.expand-item-active]="data.isSelected"
            [class.expand-item-passive]="!data.isSelected"
            [attr.data-index]="i"
            [routerLink]="[data.id]"
            (click)="subSidenavClicked(data.id, $event)"
          >
            <span class="expand-text">{{ data.subtitulo ?? data.text }}</span>
          </a>
        }
      </div>
    </ng-container>
  }
</div>
